export function formatDecimal(value?: number | null): string | undefined {
  return value == null ? undefined : value.toFixed(2)
}
